import React from "react";
import footerLogo from "./footer-logo.png";
import {
  FaWhatsappSquare,
  FaTwitterSquare,
  FaEnvelopeSquare,
  FaPhoneSquareAlt,
} from "react-icons/fa";

export default function Footer() {
  return (
    <div className="text-center bg-dark text-light p-2" id="footer">
      <img className="" src={footerLogo} alt="logo" />
      <small className="mb-2 d-flex justify-content-center">نسخة 1.0.3</small>
      <div className="mb-2">
        <button
          className="btn btn-link p-0 ml-2 "
          onClick={() => {
            window.open("https://twitter.com/as_homi", "_blank");
          }}
        >
          <FaTwitterSquare size="1.7em" />
        </button>
        <button
          className="btn btn-link p-0 "
          onClick={() => {
            window.open("#", "_blank");
          }}
        >
          <FaWhatsappSquare size="1.7em" />
        </button>
        <button
          className="btn btn-link p-0 mr-2"
          onClick={() => {
            window.open("mailto:as-homi@hanydh.com");
          }}
        >
          <FaEnvelopeSquare size="1.7em" />
        </button>
        <button
          className="btn btn-link p-0 mr-2"
          data-toggle="modal"
          data-target="#contactModal"
          onClick={() => {
            document.getElementById("mailSpinner").classList.add("d-none");
            document.getElementById("mailSuccess").classList.add("d-none");
            document.getElementById("mailFailed").classList.add("d-none");
          }}
        >
          <FaPhoneSquareAlt size="1.7em" />
        </button>
      </div>
      <small className="mb-1 ml-1 w-100 d-block">
        برمجة وتطوير
        <a target="_blank" rel="noreferrer" href="https://twitter.com/Alzahri">
          Hany<span className="text-danger mr-1">Dh</span>
        </a>
      </small>
      <small> Designed By Hany Alzahri | Copyright © 2020 HanyDh </small>
    </div>
  );
}
